import React from 'react';
import { Image } from '../../../UI/Media';

export const BannerDesktopImage = ({ desktopImage, placement }) => {
  const justifyPlacement =
    placement === 'right' ? 'justify-end' : 'justify-start';
  return (
    <div
      className={`hidden absolute md:flex ${justifyPlacement} h-full w-screen`}>
      <div
        className={`flex ${justifyPlacement} md:w-9/12 lg:w-2/3 xl:w-1/2 h-full`}>
        <Image
          {...desktopImage}
          isNative
          height='100%'
        />
      </div>
    </div>
  );
};
